/**
 * Canonical review and certification profile URLs.
 *
 * These are company-wide (Battle Creek HQ is the registered location on every
 * profile), so the same URL is correct on the homepage, the About page, and
 * every service/city page. Kept here so a moved or renamed profile is a
 * one-line change instead of a hunt through components.
 *
 * These URLs arrive as Figma comments (homepage node 349:3, About node 399:801,
 * Wyoming node 428:38). The tracking/challenge query strings in the raw comments
 * are dropped — `sca_esv`, `sxsrf`, `ved`, `biw`, `bih` and `dpr` are single-use
 * search-session tokens that expire. Only the `si` token is load-bearing.
 */

const BBB_PROFILE =
  "https://www.bbb.org/us/mi/battle-creek/profile/roofing-contractors/roach-home-improvement-llc-0372-38167467";
const HOUZZ_PROFILE =
  "https://www.houzz.com/professionals/general-contractors/roach-home-improvement-llc-pfvwus-pf~1101625575";
const GAF_PROFILE =
  "https://www.gaf.com/en-us/roofing-contractors/residential/usa/mi/battle-creek/roach-home-improvement-llc-1126014#id-1126014";
const YELP_PROFILE = "https://www.yelp.com/biz/roach-home-improvement-battle-creek";
// Google reviews panel for the business. The `si` token is what opens the
// reviews view rather than a plain search results page — keep it intact.
const GOOGLE_REVIEWS =
  "https://www.google.com/search?q=Roach+Home+Improvement,+LLC+Reviews&si=APenkKn5T4YN59srr511wD6k6Pufj9DEzRUvB1XJSwUeeT5afigT_ydCIVlYrt7fTKN-f4XRuoarvsm7eqrkBG4HTFhKt8ZbZeD2D-illexYr7IICQBmIp-ckNhh-J4NqhFydB5bLKXaAwNSj8YeoHqeuPHWBw7I_w%3D%3D";

module.exports = {
  BBB_PROFILE,
  HOUZZ_PROFILE,
  GAF_PROFILE,
  YELP_PROFILE,
  GOOGLE_REVIEWS,
};
